var map = {
	"./Music/have-sound.png": 11697,
	"./Music/no-sound.png": 50859,
	"./blackGold/Sidebar/CardIcon.png": 30500,
	"./blackGold/Sidebar/DottedSideBar.png": 6784,
	"./blackGold/Sidebar/FireIcon.png": 2326,
	"./blackGold/Sidebar/FishIcon.png": 46991,
	"./blackGold/Sidebar/SidebarBg.png": 36184,
	"./blackGold/Sidebar/SidebarText/sbhTitle.png": 39125,
	"./blackGold/Sidebar/SlotIcon.png": 30183,
	"./blackGold/Sidebar/btn-vipactive.png": 53568,
	"./blackGold/Sidebar/divider (1).png": 26195,
	"./blackGold/Sidebar/divider.png": 31269,
	"./blackGold/Sidebar/dotted-bg 1.png": 8608,
	"./blackGold/Sidebar/sb_active_item.png": 82279,
	"./blackGold/Sidebar/sidebar-bg.png": 92414,
	"./blackGold/Sidebar/sidebar-title.png": 27343,
	"./blackGold/Sidebar/text.png": 87487,
	"./blackGold/Sidebar/text2.png": 17046,
	"./blackGold/footer/Icon-chip.png": 97823,
	"./blackGold/footer/Icon-gift.png": 92312,
	"./blackGold/footer/Icon-message.png": 34156,
	"./blackGold/footer/Icon-more.png": 15763,
	"./blackGold/footer/Icon-support.png": 65085,
	"./blackGold/footer/MoreBalloon.png": 8748,
	"./blackGold/footer/bottom-bg.png": 75810,
	"./blackGold/footer/cs_icon.png": 26043,
	"./blackGold/footer/defaultIcon.png": 4727,
	"./blackGold/footer/divider.png": 59347,
	"./blackGold/footer/eye-hide.png": 28119,
	"./blackGold/footer/eye-show.png": 10894,
	"./blackGold/footer/faq.png": 76936,
	"./blackGold/footer/feedback_icon.png": 23816,
	"./blackGold/footer/megaphone.png": 57504,
	"./blackGold/footer/musiCon.png": 75553,
	"./blackGold/footer/othermodal_xbtn.png": 46582,
	"./blackGold/footer/setting_user.png": 24181,
	"./blackGold/footer/supps-icon.png": 75812,
	"./blackGold/footer/user.png": 70463,
	"./blackGold/footer/vault.png": 25691,
	"./blackGold/fragments/arrow_down.png": 51847,
	"./blackGold/fragments/arrowvector.png": 86741,
	"./blackGold/fragments/bind_card_add.png": 9781,
	"./blackGold/fragments/button2.png": 83354,
	"./blackGold/fragments/loading.png": 1775,
	"./blackGold/fragments/plusvector.png": 20966,
	"./blackGold/header/backBtn.png": 83277,
	"./blackGold/header/btn3.png": 91007,
	"./blackGold/header/btn3_2.png": 18697,
	"./blackGold/header/button2.png": 65814,
	"./blackGold/header/calendar.png": 63960,
	"./blackGold/header/coin.png": 39897,
	"./blackGold/header/copyIcon.png": 31105,
	"./blackGold/header/defaultIcon.png": 69358,
	"./blackGold/header/down-arrow 1.png": 27805,
	"./blackGold/header/game-popup_8803.png": 51411,
	"./blackGold/header/h5_icon.png": 3381,
	"./blackGold/header/header_bg.png": 31250,
	"./blackGold/header/header_logo.png": 64830,
	"./blackGold/header/header_logo_8801.png": 28522,
	"./blackGold/header/header_logo_8802.png": 39178,
	"./blackGold/header/hisLabel.png": 79372,
	"./blackGold/header/hisRecord.png": 20221,
	"./blackGold/header/home_header.png": 38986,
	"./blackGold/header/logo-app.png": 21824,
	"./blackGold/header/promote.png": 49909,
	"./blackGold/header/reg-log.png": 63595,
	"./blackGold/header/reload.png": 72248,
	"./blackGold/header/setting.png": 70611,
	"./blackGold/header/shareIcon.png": 86021,
	"./blackGold/header/shareIconLabel.png": 84299,
	"./blackGold/header/task.png": 22629,
	"./blackGold/header/txt.png": 15729,
	"./blackGold/login_register/eye-hide.png": 80988,
	"./blackGold/login_register/eye-show.png": 85458,
	"./blackGold/login_register/header.png": 36605,
	"./blackGold/login_register/lYellowBtn.png": 87990,
	"./blackGold/login_register/loginClose.png": 86105,
	"./blackGold/login_register/login_reg_bg.png": 83367,
	"./blackGold/login_register/purpleBtn.png": 63253,
	"./blackGold/login_register/rGreenBtn.png": 78389,
	"./blackGold/login_register/sharkLogin.png": 4480,
	"./blackGold/login_register/supps-icon.png": 25521,
	"./blackGold/mailbox/mailContent.png": 50992,
	"./blackGold/mailbox/mailSubject.png": 61816,
	"./blackGold/mailbox/message_icon.png": 23067,
	"./blackGold/main/DottedSideBar.png": 13894,
	"./blackGold/main/SidebarBg.png": 90929,
	"./blackGold/main/audio_icon.png": 26769,
	"./blackGold/main/cardgameback.png": 93874,
	"./blackGold/main/divider.png": 47455,
	"./blackGold/main/gametopAct.png": 66908,
	"./blackGold/main/gametopNorm.png": 42416,
	"./blackGold/main/sb_active_item.png": 76717,
	"./blackGold/main/search-bg.png": 2362,
	"./blackGold/main/search-clear.png": 1735,
	"./blackGold/main/search-icon.png": 8992,
	"./blackGold/main/sidebar_title.png": 12678,
	"./blackGold/main/trashBinLogo.png": 13470,
	"./blackGold/other_modal/7276.png": 39634,
	"./blackGold/other_modal/OtherActiveTab.png": 72506,
	"./blackGold/other_modal/OtherInactiveTab.png": 16443,
	"./blackGold/other_modal/OtherLongImagePlaceholder.png": 91648,
	"./blackGold/other_modal/OtherModalContainer.png": 87202,
	"./blackGold/other_modal/OtherModalHeader.png": 86390,
	"./blackGold/other_modal/helpIconRound.png": 12373,
	"./blackGold/other_modal/othermodal_xbtn.png": 53874,
	"./blackGold/other_modal/othermodalsbg.png": 66648,
	"./blackGold/other_modal/poplogo.png": 90495,
	"./blackGold/other_modal/withdraw_success.png": 56226,
	"./blackGold/safeBox/GreenSumthing.png": 21379,
	"./blackGold/safeBox/divider.png": 25930,
	"./blackGold/safeBox/gameWalletIcon.png": 74733,
	"./blackGold/safeBox/safeEnter.png": 52139,
	"./blackGold/safeBox/safeReset.png": 69467,
	"./blackGold/safeBox/safeboxButton.png": 82388,
	"./blackGold/safeBox/transferFromIcon.png": 15938,
	"./blackGold/safeBox/transferToIcon.png": 15120,
	"./brownGold/Sidebar/CardIcon.png": 75014,
	"./brownGold/Sidebar/DottedSideBar.png": 51055,
	"./brownGold/Sidebar/FireIcon.png": 91583,
	"./brownGold/Sidebar/FishIcon.png": 52833,
	"./brownGold/Sidebar/SidebarBg.png": 2834,
	"./brownGold/Sidebar/SidebarText/sbhTitle.png": 43668,
	"./brownGold/Sidebar/SlotIcon.png": 47971,
	"./brownGold/Sidebar/btn-actv2.png": 95213,
	"./brownGold/Sidebar/btn-vipactive.png": 66758,
	"./brownGold/Sidebar/divider.png": 67364,
	"./brownGold/Sidebar/dotted-bg 1.png": 93483,
	"./brownGold/Sidebar/sb_active_item.png": 94154,
	"./brownGold/Sidebar/sidebar-bg.png": 48630,
	"./brownGold/Sidebar/sidebar-title.png": 23319,
	"./brownGold/Sidebar/text.png": 76334,
	"./brownGold/Sidebar/text2.png": 67493,
	"./brownGold/footer/Icon-chip.png": 95064,
	"./brownGold/footer/Icon-gift.png": 81657,
	"./brownGold/footer/Icon-message.png": 68368,
	"./brownGold/footer/Icon-more.png": 54126,
	"./brownGold/footer/Icon-support.png": 72267,
	"./brownGold/footer/MoreBalloon.png": 73270,
	"./brownGold/footer/cs_icon.png": 12914,
	"./brownGold/footer/defaultIcon.png": 84415,
	"./brownGold/footer/divider.png": 26845,
	"./brownGold/footer/eye-hide.png": 86288,
	"./brownGold/footer/eye-show.png": 82608,
	"./brownGold/footer/faq.png": 51271,
	"./brownGold/footer/feedback_icon.png": 62939,
	"./brownGold/footer/megaphone.png": 50790,
	"./brownGold/footer/musiCon.png": 7643,
	"./brownGold/footer/othermodal_xbtn.png": 83259,
	"./brownGold/footer/setting_user.png": 32140,
	"./brownGold/footer/supps-icon.png": 93081,
	"./brownGold/footer/user.png": 56282,
	"./brownGold/footer/vault.png": 840,
	"./brownGold/fragments/arrow_down.png": 89300,
	"./brownGold/fragments/arrowvector.png": 6750,
	"./brownGold/fragments/bind_card_add.png": 66593,
	"./brownGold/fragments/button2.png": 30349,
	"./brownGold/fragments/down-arrow1.png": 63071,
	"./brownGold/fragments/loading.png": 26922,
	"./brownGold/fragments/nodata.png": 84056,
	"./brownGold/fragments/plusvector.png": 49537,
	"./brownGold/header/backBtn.png": 72566,
	"./brownGold/header/button2.png": 17138,
	"./brownGold/header/calendar.png": 17215,
	"./brownGold/header/coin.png": 49901,
	"./brownGold/header/copyIcon.png": 25388,
	"./brownGold/header/defaultIcon.png": 37715,
	"./brownGold/header/down-arrow 1.png": 63861,
	"./brownGold/header/h5_icon.png": 45201,
	"./brownGold/header/header_bg.png": 77099,
	"./brownGold/header/hisLabel.png": 91275,
	"./brownGold/header/hisRecord.png": 2232,
	"./brownGold/header/home_header.png": 97532,
	"./brownGold/header/logo-app.png": 75355,
	"./brownGold/header/promote.png": 98676,
	"./brownGold/header/reg-log.png": 51215,
	"./brownGold/header/reload.png": 52191,
	"./brownGold/header/setting.png": 69749,
	"./brownGold/header/shareIcon.png": 44204,
	"./brownGold/header/shareIconLabel.png": 14185,
	"./brownGold/header/task.png": 16223,
	"./brownGold/header/txt.png": 555,
	"./brownGold/login_register/eye-hide.png": 81406,
	"./brownGold/login_register/eye-show.png": 16082,
	"./brownGold/login_register/header-long.png": 82639,
	"./brownGold/login_register/header.png": 41461,
	"./brownGold/login_register/lYellowBtn.png": 14706,
	"./brownGold/login_register/loginClose.png": 44558,
	"./brownGold/login_register/login_reg_bg.png": 98475,
	"./brownGold/login_register/purpleBtn.png": 79380,
	"./brownGold/login_register/rGreenBtn.png": 58144,
	"./brownGold/login_register/sharkLogin.png": 77400,
	"./brownGold/login_register/supps-icon.png": 30572,
	"./brownGold/mailbox/mailContent.png": 658,
	"./brownGold/mailbox/mailSubject.png": 31426,
	"./brownGold/mailbox/message_icon.png": 32139,
	"./brownGold/main/DottedSideBar.png": 17081,
	"./brownGold/main/SidebarBg.png": 82218,
	"./brownGold/main/audio_icon.png": 76113,
	"./brownGold/main/cardgameback.png": 91091,
	"./brownGold/main/divider.png": 91567,
	"./brownGold/main/gametopAct.png": 49341,
	"./brownGold/main/gametopNorm.png": 53969,
	"./brownGold/main/sb_active_item.png": 31909,
	"./brownGold/main/search-bg.png": 87571,
	"./brownGold/main/search-clear.png": 19626,
	"./brownGold/main/search-icon.png": 60700,
	"./brownGold/main/sidebar_title.png": 35712,
	"./brownGold/main/trashBinLogo.png": 60425,
	"./brownGold/other_modal/OtherActiveTab.png": 40367,
	"./brownGold/other_modal/OtherInactiveTab.png": 36249,
	"./brownGold/other_modal/OtherLongImagePlaceholder.png": 11690,
	"./brownGold/other_modal/OtherModalContainer.png": 68934,
	"./brownGold/other_modal/OtherModalHeader.png": 95026,
	"./brownGold/other_modal/helpIconRound.png": 65874,
	"./brownGold/other_modal/othermodal_xbtn.png": 56279,
	"./brownGold/other_modal/othermodalsbg.png": 73575,
	"./brownGold/other_modal/poplogo.png": 24100,
	"./brownGold/other_modal/withdraw_success.png": 174,
	"./brownGold/safeBox/GreenSumthing.png": 59646,
	"./brownGold/safeBox/divider.png": 99406,
	"./brownGold/safeBox/gameWalletIcon.png": 1316,
	"./brownGold/safeBox/safeEnter.png": 65404,
	"./brownGold/safeBox/safeReset.png": 59262,
	"./brownGold/safeBox/safeboxButton.png": 28292,
	"./brownGold/safeBox/transferFromIcon.png": 51976,
	"./brownGold/safeBox/transferToIcon.png": 66058,
	"./commons/DiceImages/DiceFive.png": 20777,
	"./commons/DiceImages/DiceFour.png": 65345,
	"./commons/DiceImages/DiceOne.png": 13558,
	"./commons/DiceImages/DiceSix.png": 70580,
	"./commons/DiceImages/DiceThree.png": 443,
	"./commons/DiceImages/DiceTwo.png": 89792,
	"./commons/Fragments/arrow_down.png": 54462,
	"./commons/ImgWithFallback/onErrorImg.png": 53902,
	"./commons/Nodata/bettingBg.png": 86685,
	"./commons/VipLevels/vip1.png": 74051,
	"./commons/VipLevels/vip10.png": 55379,
	"./commons/VipLevels/vip11.png": 6534,
	"./commons/VipLevels/vip12.png": 28927,
	"./commons/VipLevels/vip13.png": 69107,
	"./commons/VipLevels/vip14.png": 48315,
	"./commons/VipLevels/vip15.png": 65632,
	"./commons/VipLevels/vip16.png": 3103,
	"./commons/VipLevels/vip17.png": 71158,
	"./commons/VipLevels/vip18.png": 25222,
	"./commons/VipLevels/vip19.png": 94404,
	"./commons/VipLevels/vip2.png": 68920,
	"./commons/VipLevels/vip20.png": 95509,
	"./commons/VipLevels/vip21.png": 37701,
	"./commons/VipLevels/vip22.png": 25324,
	"./commons/VipLevels/vip23.png": 14037,
	"./commons/VipLevels/vip24.png": 72679,
	"./commons/VipLevels/vip25.png": 59902,
	"./commons/VipLevels/vip26.png": 16729,
	"./commons/VipLevels/vip27.png": 16473,
	"./commons/VipLevels/vip28.png": 13398,
	"./commons/VipLevels/vip29.png": 52225,
	"./commons/VipLevels/vip3.png": 96111,
	"./commons/VipLevels/vip30.png": 74460,
	"./commons/VipLevels/vip31.png": 26950,
	"./commons/VipLevels/vip32.png": 93831,
	"./commons/VipLevels/vip33.png": 76693,
	"./commons/VipLevels/vip34.png": 68781,
	"./commons/VipLevels/vip35.png": 22171,
	"./commons/VipLevels/vip36.png": 47207,
	"./commons/VipLevels/vip37.png": 19647,
	"./commons/VipLevels/vip38.png": 2426,
	"./commons/VipLevels/vip39.png": 56878,
	"./commons/VipLevels/vip4.png": 64164,
	"./commons/VipLevels/vip40.png": 58026,
	"./commons/VipLevels/vip41.png": 41559,
	"./commons/VipLevels/vip42.png": 33962,
	"./commons/VipLevels/vip43.png": 78526,
	"./commons/VipLevels/vip44.png": 21778,
	"./commons/VipLevels/vip45.png": 79727,
	"./commons/VipLevels/vip46.png": 48900,
	"./commons/VipLevels/vip47.png": 77806,
	"./commons/VipLevels/vip48.png": 6484,
	"./commons/VipLevels/vip49.png": 42950,
	"./commons/VipLevels/vip5.png": 13940,
	"./commons/VipLevels/vip50.png": 63878,
	"./commons/VipLevels/vip6.png": 98484,
	"./commons/VipLevels/vip7.png": 90466,
	"./commons/VipLevels/vip8.png": 4689,
	"./commons/VipLevels/vip9.png": 19706,
	"./commons/addscreenmodal1.png": 63415,
	"./commons/addscreenmodal2.png": 61922,
	"./commons/baccarat/D-J.png": 87166,
	"./commons/baccarat/S-10.png": 51474,
	"./commons/baccarat/baccarat_game_settlement.png": 95420,
	"./commons/baccarat/baccarat_game_start_betting.png": 2989,
	"./commons/baccarat/baccarat_game_stop_betting.png": 58961,
	"./commons/baccarat/bet-amount-bg.png": 57800,
	"./commons/baccarat/cards 2.png": 8924,
	"./commons/baccarat/cards/card-back.png": 53877,
	"./commons/baccarat/cards/card-backold.png": 36875,
	"./commons/baccarat/cards/p10_1.png": 98442,
	"./commons/baccarat/cards/p10_2.png": 80554,
	"./commons/baccarat/cards/p10_3.png": 34273,
	"./commons/baccarat/cards/p10_4.png": 6573,
	"./commons/baccarat/cards/p11_1.png": 82001,
	"./commons/baccarat/cards/p11_2.png": 69022,
	"./commons/baccarat/cards/p11_3.png": 77770,
	"./commons/baccarat/cards/p11_4.png": 9685,
	"./commons/baccarat/cards/p12_1.png": 19821,
	"./commons/baccarat/cards/p12_2.png": 82002,
	"./commons/baccarat/cards/p12_3.png": 33509,
	"./commons/baccarat/cards/p12_4.png": 52855,
	"./commons/baccarat/cards/p13_1.png": 74896,
	"./commons/baccarat/cards/p13_2.png": 53322,
	"./commons/baccarat/cards/p13_3.png": 21549,
	"./commons/baccarat/cards/p13_4.png": 75869,
	"./commons/baccarat/cards/p1_1.png": 61266,
	"./commons/baccarat/cards/p1_2.png": 10571,
	"./commons/baccarat/cards/p1_3.png": 32161,
	"./commons/baccarat/cards/p1_4.png": 54564,
	"./commons/baccarat/cards/p2_1.png": 85875,
	"./commons/baccarat/cards/p2_2.png": 81203,
	"./commons/baccarat/cards/p2_3.png": 38780,
	"./commons/baccarat/cards/p2_4.png": 38810,
	"./commons/baccarat/cards/p3_1.png": 51634,
	"./commons/baccarat/cards/p3_2.png": 803,
	"./commons/baccarat/cards/p3_3.png": 54169,
	"./commons/baccarat/cards/p3_4.png": 31753,
	"./commons/baccarat/cards/p4_1.png": 81784,
	"./commons/baccarat/cards/p4_2.png": 78221,
	"./commons/baccarat/cards/p4_3.png": 46730,
	"./commons/baccarat/cards/p4_4.png": 95841,
	"./commons/baccarat/cards/p5_1.png": 89883,
	"./commons/baccarat/cards/p5_2.png": 593,
	"./commons/baccarat/cards/p5_3.png": 5807,
	"./commons/baccarat/cards/p5_4.png": 11137,
	"./commons/baccarat/cards/p6_1.png": 15087,
	"./commons/baccarat/cards/p6_2.png": 35973,
	"./commons/baccarat/cards/p6_3.png": 89277,
	"./commons/baccarat/cards/p6_4.png": 80101,
	"./commons/baccarat/cards/p7_1.png": 49879,
	"./commons/baccarat/cards/p7_2.png": 55062,
	"./commons/baccarat/cards/p7_3.png": 72508,
	"./commons/baccarat/cards/p7_4.png": 2803,
	"./commons/baccarat/cards/p8_1.png": 10422,
	"./commons/baccarat/cards/p8_2.png": 40256,
	"./commons/baccarat/cards/p8_3.png": 23026,
	"./commons/baccarat/cards/p8_4.png": 62076,
	"./commons/baccarat/cards/p9_1.png": 9534,
	"./commons/baccarat/cards/p9_2.png": 821,
	"./commons/baccarat/cards/p9_3.png": 97096,
	"./commons/baccarat/cards/p9_4.png": 25856,
	"./commons/baccarat/chip1.png": 47379,
	"./commons/baccarat/chip10.png": 6892,
	"./commons/baccarat/chip11.png": 34087,
	"./commons/baccarat/chip12.png": 35069,
	"./commons/baccarat/chip13.png": 76990,
	"./commons/baccarat/chip14.png": 95637,
	"./commons/baccarat/chip15.png": 19145,
	"./commons/baccarat/chip2.png": 24682,
	"./commons/baccarat/chip3.png": 67871,
	"./commons/baccarat/chip4.png": 49345,
	"./commons/baccarat/chip5.png": 338,
	"./commons/baccarat/chip6.png": 47939,
	"./commons/baccarat/chip7.png": 56272,
	"./commons/baccarat/chip8.png": 77894,
	"./commons/baccarat/chip9.png": 62810,
	"./commons/baccarat/chips-holder.png": 71918,
	"./commons/baccarat/close-btn.png": 38688,
	"./commons/baccarat/coins.png": 33081,
	"./commons/baccarat/musicCon.png": 91438,
	"./commons/baccarat/noSound.png": 38663,
	"./commons/baccarat/select-chips-btn.png": 14679,
	"./commons/btn-vipactive.png": 8694,
	"./commons/button1.png": 44581,
	"./commons/check.png": 89227,
	"./commons/close.png": 58554,
	"./commons/gray_tick.png": 726,
	"./commons/icons/crown-icon.png": 90163,
	"./commons/icons/promotionIcons/FourIcon.png": 92388,
	"./commons/icons/promotionIcons/OneIcon.png": 91890,
	"./commons/icons/promotionIcons/ThreeIcon.png": 18035,
	"./commons/icons/promotionIcons/TwoIcon.png": 37784,
	"./commons/icons/vipLogo.png": 70016,
	"./commons/loading_bg.png": 9284,
	"./commons/login_bg.png": 98899,
	"./commons/logo_icon.png": 4190,
	"./commons/logo_icon1.png": 71283,
	"./commons/lotteryAssets/lotteryBall.png": 27756,
	"./commons/qrShareBtn.png": 86578,
	"./commons/recharge.png": 78862,
	"./commons/reusable/ImgWithFallback/onErrorImg.png": 62849,
	"./commons/vipImages/GoPayicon.png": 37008,
	"./commons/vipImages/PersonalInfo/01-Smiley.png": 6762,
	"./commons/vipImages/PersonalInfo/02-Person.png": 23505,
	"./commons/vipImages/PersonalInfo/03-PersonBalloon.png": 46616,
	"./commons/vipImages/PersonalInfo/04-IdPerson.png": 12347,
	"./commons/vipImages/PersonalInfo/05-genderIcon.png": 81914,
	"./commons/vipImages/PersonalInfo/06-Calendar.png": 53764,
	"./commons/vipImages/PersonalInfo/07-Wifi.png": 78398,
	"./commons/vipImages/PersonalInfo/08-Penquin.png": 81040,
	"./commons/vipImages/PersonalInfo/09-WeChat.png": 83648,
	"./commons/vipImages/PersonalInfo/10-device.png": 52766,
	"./commons/vipImages/PersonalInfo/11-Message.png": 90222,
	"./commons/vipImages/PersonalInfo/bettingBg.png": 69097,
	"./commons/vipImages/PersonalInfo/blueDevice.png": 63117,
	"./commons/vipImages/VIP1.png": 49429,
	"./commons/vipImages/VIP2.png": 76030,
	"./commons/vipImages/VipLevels/vip1.png": 98874,
	"./commons/vipImages/VipLevels/vip10.png": 37765,
	"./commons/vipImages/VipLevels/vip11.png": 71086,
	"./commons/vipImages/VipLevels/vip12.png": 31681,
	"./commons/vipImages/VipLevels/vip13.png": 51650,
	"./commons/vipImages/VipLevels/vip14.png": 95527,
	"./commons/vipImages/VipLevels/vip15.png": 42739,
	"./commons/vipImages/VipLevels/vip16.png": 22331,
	"./commons/vipImages/VipLevels/vip17.png": 78620,
	"./commons/vipImages/VipLevels/vip18.png": 53297,
	"./commons/vipImages/VipLevels/vip19.png": 36645,
	"./commons/vipImages/VipLevels/vip2.png": 94035,
	"./commons/vipImages/VipLevels/vip20.png": 63479,
	"./commons/vipImages/VipLevels/vip21.png": 55332,
	"./commons/vipImages/VipLevels/vip22.png": 8648,
	"./commons/vipImages/VipLevels/vip23.png": 77800,
	"./commons/vipImages/VipLevels/vip24.png": 84722,
	"./commons/vipImages/VipLevels/vip25.png": 33273,
	"./commons/vipImages/VipLevels/vip26.png": 81377,
	"./commons/vipImages/VipLevels/vip27.png": 95510,
	"./commons/vipImages/VipLevels/vip28.png": 30646,
	"./commons/vipImages/VipLevels/vip29.png": 13814,
	"./commons/vipImages/VipLevels/vip3.png": 14876,
	"./commons/vipImages/VipLevels/vip30.png": 30075,
	"./commons/vipImages/VipLevels/vip31.png": 48322,
	"./commons/vipImages/VipLevels/vip32.png": 37799,
	"./commons/vipImages/VipLevels/vip33.png": 6805,
	"./commons/vipImages/VipLevels/vip34.png": 44982,
	"./commons/vipImages/VipLevels/vip35.png": 82957,
	"./commons/vipImages/VipLevels/vip36.png": 8810,
	"./commons/vipImages/VipLevels/vip37.png": 2742,
	"./commons/vipImages/VipLevels/vip38.png": 70477,
	"./commons/vipImages/VipLevels/vip39.png": 7556,
	"./commons/vipImages/VipLevels/vip4.png": 3785,
	"./commons/vipImages/VipLevels/vip40.png": 76346,
	"./commons/vipImages/VipLevels/vip41.png": 26023,
	"./commons/vipImages/VipLevels/vip42.png": 87682,
	"./commons/vipImages/VipLevels/vip43.png": 75594,
	"./commons/vipImages/VipLevels/vip44.png": 69149,
	"./commons/vipImages/VipLevels/vip45.png": 47900,
	"./commons/vipImages/VipLevels/vip46.png": 66429,
	"./commons/vipImages/VipLevels/vip47.png": 86838,
	"./commons/vipImages/VipLevels/vip48.png": 12226,
	"./commons/vipImages/VipLevels/vip49.png": 88900,
	"./commons/vipImages/VipLevels/vip5.png": 59238,
	"./commons/vipImages/VipLevels/vip50.png": 78371,
	"./commons/vipImages/VipLevels/vip6.png": 8431,
	"./commons/vipImages/VipLevels/vip7.png": 29237,
	"./commons/vipImages/VipLevels/vip8.png": 37425,
	"./commons/vipImages/VipLevels/vip9.png": 29523,
	"./commons/vipImages/advancement_jackpot.png": 48910,
	"./commons/vipImages/arrowvector.png": 5934,
	"./commons/vipImages/gift_icon.png": 69572,
	"./commons/vipImages/plusvector.png": 91009,
	"./commons/vipImages/promotionIcons/FourIcon.png": 79420,
	"./commons/vipImages/promotionIcons/OneIcon.png": 31469,
	"./commons/vipImages/promotionIcons/ThreeIcon.png": 71716,
	"./commons/vipImages/promotionIcons/TwoIcon.png": 92053,
	"./commons/vipImages/vipLogo.png": 92075,
	"./commons/vipPages/blueDevice.png": 11366,
	"./commons/white_tick.png": 37761,
	"./darkBlue/Sidebar/CardIcon.png": 44561,
	"./darkBlue/Sidebar/DottedSideBar.png": 5299,
	"./darkBlue/Sidebar/FireIcon.png": 92621,
	"./darkBlue/Sidebar/FishIcon.png": 75525,
	"./darkBlue/Sidebar/SidebarBg.png": 49469,
	"./darkBlue/Sidebar/SidebarText/sbhTitle.png": 31076,
	"./darkBlue/Sidebar/SlotIcon.png": 4123,
	"./darkBlue/Sidebar/btn-vipactive.png": 60475,
	"./darkBlue/Sidebar/divider.png": 93807,
	"./darkBlue/Sidebar/dotted-bg 1.png": 58775,
	"./darkBlue/Sidebar/sb_active_item.png": 51711,
	"./darkBlue/Sidebar/sidebar-bg.png": 7919,
	"./darkBlue/Sidebar/sidebar-title.png": 77426,
	"./darkBlue/Sidebar/text.png": 18705,
	"./darkBlue/Sidebar/text2.png": 15489,
	"./darkBlue/button1.png": 97472,
	"./darkBlue/footer/Icon-chip.png": 37407,
	"./darkBlue/footer/Icon-gift.png": 73097,
	"./darkBlue/footer/Icon-message.png": 39541,
	"./darkBlue/footer/Icon-more.png": 69324,
	"./darkBlue/footer/Icon-support.png": 45840,
	"./darkBlue/footer/MoreBalloon.png": 74678,
	"./darkBlue/footer/cs_icon.png": 62033,
	"./darkBlue/footer/defaultIcon.png": 70718,
	"./darkBlue/footer/divider.png": 13729,
	"./darkBlue/footer/eye-hide.png": 27679,
	"./darkBlue/footer/eye-show.png": 25769,
	"./darkBlue/footer/faq.png": 18074,
	"./darkBlue/footer/feedback_icon.png": 54149,
	"./darkBlue/footer/megaphone.png": 17949,
	"./darkBlue/footer/musiCon.png": 58190,
	"./darkBlue/footer/othermodal_xbtn.png": 91207,
	"./darkBlue/footer/setting_user.png": 45454,
	"./darkBlue/footer/supps-icon.png": 37923,
	"./darkBlue/footer/user.png": 44391,
	"./darkBlue/footer/vault.png": 87601,
	"./darkBlue/fragments/arrow_down.png": 82342,
	"./darkBlue/fragments/arrowvector.png": 54204,
	"./darkBlue/fragments/bind_card_add.png": 52770,
	"./darkBlue/fragments/button2.png": 6117,
	"./darkBlue/fragments/loading.png": 44602,
	"./darkBlue/fragments/nodata.png": 99382,
	"./darkBlue/fragments/plusvector.png": 93311,
	"./darkBlue/header/backBtn.png": 11006,
	"./darkBlue/header/button2.png": 40249,
	"./darkBlue/header/calendar.png": 28281,
	"./darkBlue/header/coin.png": 40259,
	"./darkBlue/header/copyIcon.png": 69616,
	"./darkBlue/header/defaultIcon.png": 65808,
	"./darkBlue/header/down-arrow 1.png": 93952,
	"./darkBlue/header/h5_icon.png": 6292,
	"./darkBlue/header/header_bg.png": 72150,
	"./darkBlue/header/hisLabel.png": 38067,
	"./darkBlue/header/hisRecord.png": 81676,
	"./darkBlue/header/home_header.png": 29441,
	"./darkBlue/header/logo-app.png": 74256,
	"./darkBlue/header/promote.png": 82617,
	"./darkBlue/header/reg-log.png": 10912,
	"./darkBlue/header/reload.png": 94569,
	"./darkBlue/header/setting.png": 36102,
	"./darkBlue/header/shareIcon.png": 52609,
	"./darkBlue/header/shareIconLabel.png": 17395,
	"./darkBlue/header/task.png": 20801,
	"./darkBlue/header/txt.png": 1733,
	"./darkBlue/login_register/eye-hide.png": 60677,
	"./darkBlue/login_register/eye-show.png": 78076,
	"./darkBlue/login_register/header.png": 11088,
	"./darkBlue/login_register/lYellowBtn.png": 58198,
	"./darkBlue/login_register/loginClose.png": 99852,
	"./darkBlue/login_register/login_reg_bg.png": 24414,
	"./darkBlue/login_register/purpleBtn.png": 23322,
	"./darkBlue/login_register/rGreenBtn.png": 27625,
	"./darkBlue/login_register/sharkLogin.png": 32564,
	"./darkBlue/login_register/supps-icon.png": 56961,
	"./darkBlue/mailbox/mailContent.png": 62715,
	"./darkBlue/mailbox/mailSubject.png": 6394,
	"./darkBlue/mailbox/message_icon.png": 8594,
	"./darkBlue/main/DottedSideBar.png": 20507,
	"./darkBlue/main/SidebarBg.png": 67,
	"./darkBlue/main/audio_icon.png": 91363,
	"./darkBlue/main/cardgameback.png": 89122,
	"./darkBlue/main/divider.png": 60858,
	"./darkBlue/main/gametopAct-2.png": 47181,
	"./darkBlue/main/gametopAct.png": 68048,
	"./darkBlue/main/gametopNorm.png": 82414,
	"./darkBlue/main/sb_active_item.png": 88995,
	"./darkBlue/main/search-bg.png": 24108,
	"./darkBlue/main/search-clear.png": 98732,
	"./darkBlue/main/search-icon.png": 1663,
	"./darkBlue/main/sidebar_title.png": 21634,
	"./darkBlue/main/trashBinLogo.png": 65363,
	"./darkBlue/other_modal/OtherActiveTab.png": 33080,
	"./darkBlue/other_modal/OtherInactiveTab.png": 36795,
	"./darkBlue/other_modal/OtherLongImagePlaceholder.png": 89091,
	"./darkBlue/other_modal/OtherModalContainer.png": 35356,
	"./darkBlue/other_modal/OtherModalHeader.png": 75915,
	"./darkBlue/other_modal/helpIconRound.png": 88486,
	"./darkBlue/other_modal/othermodal_xbtn.png": 7782,
	"./darkBlue/other_modal/othermodalsbg.png": 4662,
	"./darkBlue/other_modal/poplogo.png": 68163,
	"./darkBlue/other_modal/withdraw_success.png": 28340,
	"./darkBlue/safeBox/GreenSumthing.png": 64791,
	"./darkBlue/safeBox/divider.png": 68894,
	"./darkBlue/safeBox/gameWalletIcon.png": 90295,
	"./darkBlue/safeBox/safeEnter.png": 47936,
	"./darkBlue/safeBox/safeReset.png": 81596,
	"./darkBlue/safeBox/safeboxButton.png": 12170,
	"./darkBlue/safeBox/transferFromIcon.png": 9302,
	"./darkBlue/safeBox/transferToIcon.png": 50355,
	"./darkBlue/vip/crown.png": 43977,
	"./greenYellow/Sidebar/CardIcon.png": 68915,
	"./greenYellow/Sidebar/DottedSideBar.png": 74569,
	"./greenYellow/Sidebar/FireIcon.png": 2272,
	"./greenYellow/Sidebar/FishIcon.png": 80697,
	"./greenYellow/Sidebar/SidebarBg.png": 96814,
	"./greenYellow/Sidebar/SidebarText/sbhTitle.png": 99571,
	"./greenYellow/Sidebar/SlotIcon.png": 11583,
	"./greenYellow/Sidebar/btn-actv2.png": 45317,
	"./greenYellow/Sidebar/btn-vipactive.png": 41624,
	"./greenYellow/Sidebar/divider.png": 91923,
	"./greenYellow/Sidebar/dotted-bg 1.png": 82684,
	"./greenYellow/Sidebar/sb_active_item.png": 37813,
	"./greenYellow/Sidebar/sidebar-bg.png": 38349,
	"./greenYellow/Sidebar/sidebar-title.png": 16209,
	"./greenYellow/Sidebar/text.png": 94655,
	"./greenYellow/Sidebar/text2.png": 54626,
	"./greenYellow/footer/Icon-chip.png": 17298,
	"./greenYellow/footer/Icon-gift.png": 12615,
	"./greenYellow/footer/Icon-message.png": 5302,
	"./greenYellow/footer/Icon-more.png": 83161,
	"./greenYellow/footer/Icon-support.png": 13979,
	"./greenYellow/footer/MoreBalloon.png": 41631,
	"./greenYellow/footer/cs_icon.png": 42742,
	"./greenYellow/footer/defaultIcon.png": 65542,
	"./greenYellow/footer/divider.png": 78814,
	"./greenYellow/footer/eye-hide.png": 16614,
	"./greenYellow/footer/eye-show.png": 14831,
	"./greenYellow/footer/faq.png": 53587,
	"./greenYellow/footer/feedback_icon.png": 68935,
	"./greenYellow/footer/megaphone.png": 88121,
	"./greenYellow/footer/musiCon.png": 81192,
	"./greenYellow/footer/othermodal_xbtn.png": 77876,
	"./greenYellow/footer/setting_user.png": 72066,
	"./greenYellow/footer/supps-icon.png": 6204,
	"./greenYellow/footer/user.png": 81187,
	"./greenYellow/footer/vault.png": 81881,
	"./greenYellow/fragments/arrow_down.png": 9654,
	"./greenYellow/fragments/arrowvector.png": 73348,
	"./greenYellow/fragments/bind_card_add.png": 91621,
	"./greenYellow/fragments/borderbutton.png": 82050,
	"./greenYellow/fragments/button2.png": 11238,
	"./greenYellow/fragments/loading.png": 8592,
	"./greenYellow/fragments/nodata.png": 59102,
	"./greenYellow/fragments/plusvector.png": 45517,
	"./greenYellow/header/backBtn.png": 82338,
	"./greenYellow/header/button2.png": 94703,
	"./greenYellow/header/calendar.png": 17420,
	"./greenYellow/header/coin.png": 6183,
	"./greenYellow/header/copyIcon.png": 93051,
	"./greenYellow/header/defaultIcon.png": 72349,
	"./greenYellow/header/down-arrow 1.png": 66601,
	"./greenYellow/header/h5_icon.png": 33067,
	"./greenYellow/header/header_bg.png": 62060,
	"./greenYellow/header/hisLabel.png": 52180,
	"./greenYellow/header/hisRecord.png": 2477,
	"./greenYellow/header/home_header.png": 86901,
	"./greenYellow/header/logo-app.png": 74269,
	"./greenYellow/header/promote.png": 78969,
	"./greenYellow/header/reg-log.png": 75852,
	"./greenYellow/header/reload.png": 27966,
	"./greenYellow/header/setting.png": 77676,
	"./greenYellow/header/shareIcon.png": 15585,
	"./greenYellow/header/shareIconLabel.png": 57645,
	"./greenYellow/header/task.png": 3072,
	"./greenYellow/header/txt.png": 37774,
	"./greenYellow/login_register/eye-hide.png": 19888,
	"./greenYellow/login_register/eye-show.png": 55775,
	"./greenYellow/login_register/header.png": 38222,
	"./greenYellow/login_register/lYellowBtn.png": 19459,
	"./greenYellow/login_register/loginClose.png": 19541,
	"./greenYellow/login_register/login_reg_bg.png": 68641,
	"./greenYellow/login_register/purpleBtn.png": 32475,
	"./greenYellow/login_register/rGreenBtn.png": 96035,
	"./greenYellow/login_register/sharkLogin.png": 21650,
	"./greenYellow/login_register/supps-icon.png": 62609,
	"./greenYellow/mailbox/mailContent.png": 80020,
	"./greenYellow/mailbox/mailSubject.png": 80102,
	"./greenYellow/mailbox/message_icon.png": 63581,
	"./greenYellow/main/DottedSideBar.png": 41714,
	"./greenYellow/main/SidebarBg.png": 75019,
	"./greenYellow/main/audio_icon.png": 46213,
	"./greenYellow/main/cardgameback.png": 73369,
	"./greenYellow/main/divider.png": 1396,
	"./greenYellow/main/gametopAct-2.png": 38386,
	"./greenYellow/main/gametopAct.png": 94690,
	"./greenYellow/main/gametopNorm.png": 88700,
	"./greenYellow/main/image 31.png": 86096,
	"./greenYellow/main/sb_active_item.png": 85073,
	"./greenYellow/main/search-bg.png": 11919,
	"./greenYellow/main/search-clear.png": 24392,
	"./greenYellow/main/search-clear2.png": 24520,
	"./greenYellow/main/search-icon.png": 55891,
	"./greenYellow/main/search-icon2.png": 66954,
	"./greenYellow/main/sidebar_title.png": 5624,
	"./greenYellow/main/trashBinLogo.png": 29109,
	"./greenYellow/other_modal/OtherActiveTab.png": 54369,
	"./greenYellow/other_modal/OtherInactiveTab.png": 61721,
	"./greenYellow/other_modal/OtherLongImagePlaceholder.png": 1290,
	"./greenYellow/other_modal/OtherModalContainer.png": 93550,
	"./greenYellow/other_modal/OtherModalHeader.png": 87813,
	"./greenYellow/other_modal/helpIconRound.png": 63575,
	"./greenYellow/other_modal/othermodal_xbtn.png": 67123,
	"./greenYellow/other_modal/othermodalsbg.png": 22052,
	"./greenYellow/other_modal/poplogo.png": 42307,
	"./greenYellow/other_modal/withdraw_success.png": 18063,
	"./greenYellow/safeBox/GreenSumthing.png": 30855,
	"./greenYellow/safeBox/divider.png": 45322,
	"./greenYellow/safeBox/gameWalletIcon.png": 13174,
	"./greenYellow/safeBox/safeEnter.png": 67571,
	"./greenYellow/safeBox/safeReset.png": 53900,
	"./greenYellow/safeBox/safeboxButton.png": 73207,
	"./greenYellow/safeBox/transferFromIcon.png": 36413,
	"./greenYellow/safeBox/transferToIcon.png": 39594,
	"./redGold/Sidebar/CardIcon.png": 76196,
	"./redGold/Sidebar/DottedSideBar.png": 76822,
	"./redGold/Sidebar/FireIcon.png": 74390,
	"./redGold/Sidebar/FishIcon.png": 10142,
	"./redGold/Sidebar/SidebarBg.png": 78565,
	"./redGold/Sidebar/SidebarText/sbhTitle.png": 38166,
	"./redGold/Sidebar/SlotIcon.png": 84585,
	"./redGold/Sidebar/btn-vipactive.png": 4467,
	"./redGold/Sidebar/divider.png": 3192,
	"./redGold/Sidebar/dotted-bg 1.png": 58362,
	"./redGold/Sidebar/sb_active_item.png": 29296,
	"./redGold/Sidebar/sidebar-bg.png": 12666,
	"./redGold/Sidebar/sidebar-title.png": 21234,
	"./redGold/Sidebar/text.png": 74330,
	"./redGold/Sidebar/text2.png": 27147,
	"./redGold/footer/Icon-chip.png": 77756,
	"./redGold/footer/Icon-gift.png": 56,
	"./redGold/footer/Icon-message.png": 74897,
	"./redGold/footer/Icon-more.png": 24279,
	"./redGold/footer/Icon-support.png": 38909,
	"./redGold/footer/MoreBalloon.png": 14334,
	"./redGold/footer/cs_icon.png": 34458,
	"./redGold/footer/defaultIcon.png": 35266,
	"./redGold/footer/divider.png": 32919,
	"./redGold/footer/eye-hide.png": 97881,
	"./redGold/footer/eye-show.png": 67185,
	"./redGold/footer/faq.png": 55649,
	"./redGold/footer/feedback_icon.png": 703,
	"./redGold/footer/game_history_more.png": 17757,
	"./redGold/footer/megaphone.png": 28965,
	"./redGold/footer/musiCon.png": 75779,
	"./redGold/footer/othermodal_xbtn.png": 15745,
	"./redGold/footer/setting_user.png": 86670,
	"./redGold/footer/supps-icon.png": 46588,
	"./redGold/footer/user.png": 7404,
	"./redGold/footer/vault.png": 89386,
	"./redGold/fragments/arrow_down.png": 56990,
	"./redGold/fragments/arrowvector.png": 77363,
	"./redGold/fragments/bind_card_add.png": 14949,
	"./redGold/fragments/button2.png": 70722,
	"./redGold/fragments/loading.png": 61979,
	"./redGold/fragments/nodata.png": 73640,
	"./redGold/fragments/plusvector.png": 98046,
	"./redGold/header/backBtn.png": 67763,
	"./redGold/header/button2.png": 80601,
	"./redGold/header/calendar.png": 23091,
	"./redGold/header/coin.png": 56877,
	"./redGold/header/copyIcon.png": 62242,
	"./redGold/header/defaultIcon.png": 6062,
	"./redGold/header/down-arrow 1.png": 42184,
	"./redGold/header/h5_icon.png": 98907,
	"./redGold/header/header_bg.png": 13858,
	"./redGold/header/hisLabel.png": 79286,
	"./redGold/header/hisRecord.png": 91509,
	"./redGold/header/home_header.png": 9791,
	"./redGold/header/logo-app.png": 83796,
	"./redGold/header/promote.png": 22070,
	"./redGold/header/reg-log.png": 95085,
	"./redGold/header/reload.png": 27494,
	"./redGold/header/setting.png": 17688,
	"./redGold/header/shareIcon.png": 4273,
	"./redGold/header/shareIconLabel.png": 1098,
	"./redGold/header/task.png": 24053,
	"./redGold/header/txt.png": 92264,
	"./redGold/login_register/eye-hide.png": 21361,
	"./redGold/login_register/eye-show.png": 64356,
	"./redGold/login_register/header.png": 2422,
	"./redGold/login_register/lYellowBtn.png": 7372,
	"./redGold/login_register/loginClose.png": 43065,
	"./redGold/login_register/login_reg_bg.png": 32857,
	"./redGold/login_register/purpleBtn.png": 67459,
	"./redGold/login_register/rGreenBtn.png": 79026,
	"./redGold/login_register/sharkLogin.png": 68923,
	"./redGold/login_register/supps-icon.png": 72885,
	"./redGold/mailbox/mailContent.png": 72485,
	"./redGold/mailbox/mailSubject.png": 44336,
	"./redGold/mailbox/message_icon.png": 99423,
	"./redGold/main/DottedSideBar.png": 27508,
	"./redGold/main/SidebarBg.png": 13850,
	"./redGold/main/audio_icon.png": 44640,
	"./redGold/main/cardgameback.png": 66861,
	"./redGold/main/divider.png": 42043,
	"./redGold/main/gametopAct.png": 6788,
	"./redGold/main/gametopNorm.png": 98116,
	"./redGold/main/sb_active_item.png": 40682,
	"./redGold/main/search-bg.png": 82377,
	"./redGold/main/search-clear.png": 3523,
	"./redGold/main/search-clear2.png": 26244,
	"./redGold/main/search-icon.png": 67498,
	"./redGold/main/sidebar_title.png": 16924,
	"./redGold/main/trashBinLogo.png": 95117,
	"./redGold/other_modal/OtherActiveTab.png": 68613,
	"./redGold/other_modal/OtherInactiveTab.png": 423,
	"./redGold/other_modal/OtherLongImagePlaceholder.png": 39500,
	"./redGold/other_modal/OtherModalContainer.png": 82096,
	"./redGold/other_modal/OtherModalHeader.png": 716,
	"./redGold/other_modal/helpIconRound.png": 12417,
	"./redGold/other_modal/othermodal_xbtn.png": 69066,
	"./redGold/other_modal/othermodalsbg.png": 33060,
	"./redGold/other_modal/poplogo.png": 16195,
	"./redGold/other_modal/withdraw_success.png": 85832,
	"./redGold/safeBox/GreenSumthing.png": 84911,
	"./redGold/safeBox/divider.png": 92010,
	"./redGold/safeBox/gameWalletIcon.png": 66935,
	"./redGold/safeBox/safeEnter.png": 66875,
	"./redGold/safeBox/safeReset.png": 67333,
	"./redGold/safeBox/safeboxButton.png": 88165,
	"./redGold/safeBox/transferFromIcon.png": 81418,
	"./redGold/safeBox/transferToIcon.png": 9197,
	"./skyBlue/Sidebar/CardIcon.png": 3020,
	"./skyBlue/Sidebar/DottedSideBar.png": 15790,
	"./skyBlue/Sidebar/FireIcon.png": 25207,
	"./skyBlue/Sidebar/FishIcon.png": 40133,
	"./skyBlue/Sidebar/SidebarBg.png": 65485,
	"./skyBlue/Sidebar/SidebarText/sbhTitle.png": 23923,
	"./skyBlue/Sidebar/SlotIcon.png": 45003,
	"./skyBlue/Sidebar/btn-actv2.png": 24493,
	"./skyBlue/Sidebar/btn-vipactive.png": 19508,
	"./skyBlue/Sidebar/divider.png": 78782,
	"./skyBlue/Sidebar/dotted-bg 1.png": 96669,
	"./skyBlue/Sidebar/sb_active_item.png": 46744,
	"./skyBlue/Sidebar/sidebar-bg.png": 46940,
	"./skyBlue/Sidebar/sidebar-title.png": 38759,
	"./skyBlue/Sidebar/text.png": 98083,
	"./skyBlue/Sidebar/text2.png": 22200,
	"./skyBlue/footer/Icon-chip.png": 17851,
	"./skyBlue/footer/Icon-gift.png": 33773,
	"./skyBlue/footer/Icon-message.png": 24153,
	"./skyBlue/footer/Icon-more.png": 62376,
	"./skyBlue/footer/Icon-support.png": 58853,
	"./skyBlue/footer/MoreBalloon.png": 88264,
	"./skyBlue/footer/cs_icon.png": 84974,
	"./skyBlue/footer/defaultIcon.png": 34583,
	"./skyBlue/footer/divider.png": 36428,
	"./skyBlue/footer/eye-hide.png": 97195,
	"./skyBlue/footer/eye-show.png": 80741,
	"./skyBlue/footer/faq.png": 96036,
	"./skyBlue/footer/feedback_icon.png": 89934,
	"./skyBlue/footer/megaphone.png": 52762,
	"./skyBlue/footer/musiCon.png": 6362,
	"./skyBlue/footer/othermodal_xbtn.png": 17964,
	"./skyBlue/footer/setting_user.png": 52548,
	"./skyBlue/footer/supps-icon.png": 4824,
	"./skyBlue/footer/user.png": 20936,
	"./skyBlue/footer/vault.png": 34656,
	"./skyBlue/fragments/arrow_down.png": 48413,
	"./skyBlue/fragments/arrowvector.png": 79960,
	"./skyBlue/fragments/bind_card_add.png": 40100,
	"./skyBlue/fragments/button2.png": 51398,
	"./skyBlue/fragments/loading.png": 69625,
	"./skyBlue/fragments/nodata.png": 58240,
	"./skyBlue/fragments/plusvector.png": 91027,
	"./skyBlue/header/backBtn.png": 77695,
	"./skyBlue/header/button2.png": 38136,
	"./skyBlue/header/calendar.png": 61154,
	"./skyBlue/header/coin.png": 23573,
	"./skyBlue/header/copyIcon.png": 9980,
	"./skyBlue/header/defaultIcon.png": 16951,
	"./skyBlue/header/down-arrow 1.png": 54359,
	"./skyBlue/header/h5_icon.png": 38227,
	"./skyBlue/header/header_bg.png": 89235,
	"./skyBlue/header/hisLabel.png": 60104,
	"./skyBlue/header/hisRecord.png": 14019,
	"./skyBlue/header/home_header.png": 23819,
	"./skyBlue/header/logo-app.png": 96279,
	"./skyBlue/header/promote.png": 46279,
	"./skyBlue/header/reg-log.png": 33569,
	"./skyBlue/header/reload.png": 67474,
	"./skyBlue/header/setting.png": 50777,
	"./skyBlue/header/shareIcon.png": 7132,
	"./skyBlue/header/shareIconLabel.png": 27696,
	"./skyBlue/header/task.png": 47205,
	"./skyBlue/header/txt.png": 93005,
	"./skyBlue/login_register/eye-hide.png": 20911,
	"./skyBlue/login_register/eye-show.png": 1152,
	"./skyBlue/login_register/header.png": 54856,
	"./skyBlue/login_register/lYellowBtn.png": 67422,
	"./skyBlue/login_register/loginClose.png": 48139,
	"./skyBlue/login_register/login_reg_bg.png": 30936,
	"./skyBlue/login_register/purpleBtn.png": 15826,
	"./skyBlue/login_register/rGreenBtn.png": 59422,
	"./skyBlue/login_register/sharkLogin.png": 7901,
	"./skyBlue/login_register/supps-icon.png": 21423,
	"./skyBlue/mailbox/mailContent.png": 90144,
	"./skyBlue/mailbox/mailSubject.png": 59544,
	"./skyBlue/mailbox/message_icon.png": 25593,
	"./skyBlue/main/DottedSideBar.png": 61004,
	"./skyBlue/main/SidebarBg.png": 35734,
	"./skyBlue/main/audio_icon.png": 85884,
	"./skyBlue/main/cardgameback.png": 5520,
	"./skyBlue/main/divider.png": 22486,
	"./skyBlue/main/gametopAct.png": 19958,
	"./skyBlue/main/gametopNorm.png": 48213,
	"./skyBlue/main/sb_active_item.png": 15437,
	"./skyBlue/main/search-bg.png": 61898,
	"./skyBlue/main/search-clear.png": 73267,
	"./skyBlue/main/search-clear2.png": 45360,
	"./skyBlue/main/search-icon.png": 23605,
	"./skyBlue/main/search-icon2.png": 61048,
	"./skyBlue/main/sidebar_title.png": 80666,
	"./skyBlue/main/trashBinLogo.png": 95376,
	"./skyBlue/other_modal/OtherActiveTab.png": 46185,
	"./skyBlue/other_modal/OtherInactiveTab.png": 73424,
	"./skyBlue/other_modal/OtherLongImagePlaceholder.png": 49365,
	"./skyBlue/other_modal/OtherModalContainer.png": 70701,
	"./skyBlue/other_modal/OtherModalHeader.png": 20203,
	"./skyBlue/other_modal/helpIconRound.png": 72166,
	"./skyBlue/other_modal/othermodal_xbtn.png": 55319,
	"./skyBlue/other_modal/othermodalsbg.png": 60880,
	"./skyBlue/other_modal/poplogo.png": 44588,
	"./skyBlue/other_modal/withdraw_success.png": 24968,
	"./skyBlue/safeBox/GreenSumthing.png": 5629,
	"./skyBlue/safeBox/divider.png": 62911,
	"./skyBlue/safeBox/gameWalletIcon.png": 10151,
	"./skyBlue/safeBox/safeEnter.png": 74475,
	"./skyBlue/safeBox/safeReset.png": 34642,
	"./skyBlue/safeBox/safeboxButton.png": 75314,
	"./skyBlue/safeBox/transferFromIcon.png": 23459,
	"./skyBlue/safeBox/transferToIcon.png": 34627,
	"./whiteGold/Sidebar/CardIcon.png": 18742,
	"./whiteGold/Sidebar/DottedSideBar.png": 35815,
	"./whiteGold/Sidebar/FireIcon.png": 98886,
	"./whiteGold/Sidebar/FishIcon.png": 36239,
	"./whiteGold/Sidebar/SidebarBg.png": 47306,
	"./whiteGold/Sidebar/SidebarText/sbhTitle.png": 90630,
	"./whiteGold/Sidebar/SlotIcon.png": 49309,
	"./whiteGold/Sidebar/btn-vipactive.png": 7470,
	"./whiteGold/Sidebar/divider.png": 63765,
	"./whiteGold/Sidebar/dotted-bg 1.png": 26304,
	"./whiteGold/Sidebar/sb_active_item.png": 48313,
	"./whiteGold/Sidebar/sidebar-bg.png": 17624,
	"./whiteGold/Sidebar/sidebar-title.png": 34319,
	"./whiteGold/Sidebar/text.png": 43864,
	"./whiteGold/Sidebar/text2.png": 37889,
	"./whiteGold/footer/Icon-chip.png": 66778,
	"./whiteGold/footer/Icon-gift.png": 31825,
	"./whiteGold/footer/Icon-message.png": 70428,
	"./whiteGold/footer/Icon-more.png": 29982,
	"./whiteGold/footer/Icon-support.png": 44208,
	"./whiteGold/footer/MoreBalloon.png": 67065,
	"./whiteGold/footer/cs_icon.png": 20840,
	"./whiteGold/footer/defaultIcon.png": 79761,
	"./whiteGold/footer/divider.png": 49174,
	"./whiteGold/footer/eye-hide.png": 90924,
	"./whiteGold/footer/eye-show.png": 85357,
	"./whiteGold/footer/faq.png": 63596,
	"./whiteGold/footer/feedback_icon.png": 14738,
	"./whiteGold/footer/megaphone.png": 99486,
	"./whiteGold/footer/musiCon.png": 98441,
	"./whiteGold/footer/othermodal_xbtn.png": 4417,
	"./whiteGold/footer/setting_user.png": 22089,
	"./whiteGold/footer/supps-icon.png": 37769,
	"./whiteGold/footer/user.png": 84486,
	"./whiteGold/footer/vault.png": 7977,
	"./whiteGold/fragments/arrow_down.png": 30977,
	"./whiteGold/fragments/arrowvector.png": 12912,
	"./whiteGold/fragments/bind_card_add.png": 91756,
	"./whiteGold/fragments/button2.png": 50721,
	"./whiteGold/fragments/loading.png": 97509,
	"./whiteGold/fragments/nodata.png": 72448,
	"./whiteGold/fragments/plusvector.png": 15015,
	"./whiteGold/header/backBtn.png": 37458,
	"./whiteGold/header/button2.png": 63808,
	"./whiteGold/header/calendar.png": 94038,
	"./whiteGold/header/coin.png": 76697,
	"./whiteGold/header/copyIcon.png": 94367,
	"./whiteGold/header/defaultIcon.png": 51441,
	"./whiteGold/header/down-arrow 1.png": 28391,
	"./whiteGold/header/h5_icon.png": 1644,
	"./whiteGold/header/header_bg.png": 51621,
	"./whiteGold/header/hisLabel.png": 40126,
	"./whiteGold/header/hisRecord.png": 49346,
	"./whiteGold/header/home_header.png": 71373,
	"./whiteGold/header/logo-app.png": 48572,
	"./whiteGold/header/promote.png": 31899,
	"./whiteGold/header/reg-log.png": 81626,
	"./whiteGold/header/reload.png": 51448,
	"./whiteGold/header/setting.png": 20171,
	"./whiteGold/header/shareIcon.png": 15820,
	"./whiteGold/header/shareIconLabel.png": 79507,
	"./whiteGold/header/task.png": 72208,
	"./whiteGold/header/txt.png": 43098,
	"./whiteGold/login_register/eye-hide.png": 47710,
	"./whiteGold/login_register/eye-show.png": 72069,
	"./whiteGold/login_register/header.png": 57790,
	"./whiteGold/login_register/lYellowBtn.png": 28736,
	"./whiteGold/login_register/loginClose.png": 38112,
	"./whiteGold/login_register/login_reg_bg.png": 12800,
	"./whiteGold/login_register/purpleBtn.png": 90964,
	"./whiteGold/login_register/rGreenBtn.png": 11545,
	"./whiteGold/login_register/sharkLogin.png": 50113,
	"./whiteGold/login_register/supps-icon.png": 63089,
	"./whiteGold/mailbox/mailContent.png": 44319,
	"./whiteGold/mailbox/mailSubject.png": 81189,
	"./whiteGold/mailbox/message_icon.png": 95845,
	"./whiteGold/main/DottedSideBar.png": 35553,
	"./whiteGold/main/SidebarBg.png": 94984,
	"./whiteGold/main/audio_icon.png": 47293,
	"./whiteGold/main/cardgameback.png": 89669,
	"./whiteGold/main/divider.png": 31503,
	"./whiteGold/main/gametopAct-2.png": 24688,
	"./whiteGold/main/gametopAct.png": 5076,
	"./whiteGold/main/gametopNorm.png": 4293,
	"./whiteGold/main/sb_active_item.png": 96192,
	"./whiteGold/main/search-bg.png": 90505,
	"./whiteGold/main/search-clear.png": 9989,
	"./whiteGold/main/search-clear2.png": 25985,
	"./whiteGold/main/search-icon.png": 28888,
	"./whiteGold/main/search-icon2.png": 83540,
	"./whiteGold/main/sidebar_title.png": 22333,
	"./whiteGold/main/trashBinLogo.png": 69761,
	"./whiteGold/other_modal/OtherActiveTab.png": 22069,
	"./whiteGold/other_modal/OtherInactiveTab.png": 17629,
	"./whiteGold/other_modal/OtherLongImagePlaceholder.png": 13649,
	"./whiteGold/other_modal/OtherModalContainer.png": 92485,
	"./whiteGold/other_modal/OtherModalHeader.png": 99283,
	"./whiteGold/other_modal/helpIconRound.png": 91019,
	"./whiteGold/other_modal/othermodal_xbtn.png": 41449,
	"./whiteGold/other_modal/othermodalsbg.png": 98382,
	"./whiteGold/other_modal/poplogo.png": 21267,
	"./whiteGold/other_modal/withdraw_success.png": 3469,
	"./whiteGold/safeBox/GreenSumthing.png": 32053,
	"./whiteGold/safeBox/divider.png": 40982,
	"./whiteGold/safeBox/gameWalletIcon.png": 32821,
	"./whiteGold/safeBox/safeEnter.png": 7130,
	"./whiteGold/safeBox/safeReset.png": 1622,
	"./whiteGold/safeBox/safeboxButton.png": 98323,
	"./whiteGold/safeBox/transferFromIcon.png": 77639,
	"./whiteGold/safeBox/transferToIcon.png": 7583,
	"./whiteGold/vip/crown.png": 70298,
	"./yellowWhite/Sidebar/CardIcon.png": 39286,
	"./yellowWhite/Sidebar/DottedSideBar.png": 55804,
	"./yellowWhite/Sidebar/FireIcon.png": 21020,
	"./yellowWhite/Sidebar/FishIcon.png": 7061,
	"./yellowWhite/Sidebar/SidebarBg.png": 88072,
	"./yellowWhite/Sidebar/SidebarText/sbhTitle.png": 2623,
	"./yellowWhite/Sidebar/SlotIcon.png": 39876,
	"./yellowWhite/Sidebar/btn-actv2.png": 36827,
	"./yellowWhite/Sidebar/btn-vipactive.png": 58532,
	"./yellowWhite/Sidebar/divider.png": 28255,
	"./yellowWhite/Sidebar/dotted-bg 1.png": 54205,
	"./yellowWhite/Sidebar/sb_active_item.png": 33185,
	"./yellowWhite/Sidebar/sidebar-bg.png": 15370,
	"./yellowWhite/Sidebar/sidebar-title.png": 58251,
	"./yellowWhite/Sidebar/text.png": 11378,
	"./yellowWhite/Sidebar/text2.png": 81289,
	"./yellowWhite/footer/Icon-chip.png": 88618,
	"./yellowWhite/footer/Icon-gift.png": 41676,
	"./yellowWhite/footer/Icon-message.png": 15575,
	"./yellowWhite/footer/Icon-more.png": 4516,
	"./yellowWhite/footer/Icon-support.png": 10593,
	"./yellowWhite/footer/MoreBalloon.png": 70817,
	"./yellowWhite/footer/cs_icon.png": 14336,
	"./yellowWhite/footer/defaultIcon.png": 37433,
	"./yellowWhite/footer/divider.png": 73631,
	"./yellowWhite/footer/eye-hide.png": 38296,
	"./yellowWhite/footer/eye-show.png": 2065,
	"./yellowWhite/footer/faq.png": 84832,
	"./yellowWhite/footer/feedback_icon.png": 15544,
	"./yellowWhite/footer/megaphone.png": 73176,
	"./yellowWhite/footer/musiCon.png": 39756,
	"./yellowWhite/footer/othermodal_xbtn.png": 7318,
	"./yellowWhite/footer/setting_user.png": 25069,
	"./yellowWhite/footer/supps-icon.png": 5112,
	"./yellowWhite/footer/user.png": 18394,
	"./yellowWhite/footer/vault.png": 19994,
	"./yellowWhite/fragments/arrow_down.png": 80774,
	"./yellowWhite/fragments/arrowvector.png": 78975,
	"./yellowWhite/fragments/bind_card_add.png": 64409,
	"./yellowWhite/fragments/button2.png": 83989,
	"./yellowWhite/fragments/loading.png": 80648,
	"./yellowWhite/fragments/nodata.png": 95331,
	"./yellowWhite/fragments/plusvector.png": 27238,
	"./yellowWhite/header/backBtn.png": 25848,
	"./yellowWhite/header/button2.png": 60589,
	"./yellowWhite/header/calendar.png": 15047,
	"./yellowWhite/header/coin.png": 16106,
	"./yellowWhite/header/copyIcon.png": 88878,
	"./yellowWhite/header/defaultIcon.png": 74440,
	"./yellowWhite/header/down-arrow 1.png": 41933,
	"./yellowWhite/header/h5_icon.png": 43514,
	"./yellowWhite/header/header_bg.png": 88643,
	"./yellowWhite/header/hisLabel.png": 56371,
	"./yellowWhite/header/hisRecord.png": 89940,
	"./yellowWhite/header/home_header.png": 45270,
	"./yellowWhite/header/logo-app.png": 70753,
	"./yellowWhite/header/promote.png": 59369,
	"./yellowWhite/header/reg-log.png": 46,
	"./yellowWhite/header/reload.png": 83950,
	"./yellowWhite/header/setting.png": 18632,
	"./yellowWhite/header/shareIcon.png": 10438,
	"./yellowWhite/header/shareIconLabel.png": 90568,
	"./yellowWhite/header/task.png": 39204,
	"./yellowWhite/header/txt.png": 41428,
	"./yellowWhite/login_register/eye-hide.png": 75505,
	"./yellowWhite/login_register/eye-show.png": 87502,
	"./yellowWhite/login_register/header.png": 92231,
	"./yellowWhite/login_register/lYellowBtn.png": 50823,
	"./yellowWhite/login_register/loginClose.png": 32460,
	"./yellowWhite/login_register/login_reg_bg.png": 56107,
	"./yellowWhite/login_register/purpleBtn.png": 73449,
	"./yellowWhite/login_register/rGreenBtn.png": 95175,
	"./yellowWhite/login_register/sharkLogin.png": 2510,
	"./yellowWhite/login_register/supps-icon.png": 98797,
	"./yellowWhite/mailbox/mailContent.png": 23192,
	"./yellowWhite/mailbox/mailSubject.png": 89433,
	"./yellowWhite/mailbox/message_icon.png": 79756,
	"./yellowWhite/main/DottedSideBar.png": 21932,
	"./yellowWhite/main/SidebarBg.png": 25904,
	"./yellowWhite/main/audio_icon.png": 22355,
	"./yellowWhite/main/cardgameback.png": 68834,
	"./yellowWhite/main/divider.png": 16858,
	"./yellowWhite/main/gametopAct-2.png": 84984,
	"./yellowWhite/main/gametopAct.png": 84412,
	"./yellowWhite/main/gametopNorm.png": 20117,
	"./yellowWhite/main/sb_active_item.png": 69187,
	"./yellowWhite/main/search-bg.png": 86432,
	"./yellowWhite/main/search-clear.png": 83702,
	"./yellowWhite/main/search-icon.png": 15288,
	"./yellowWhite/main/sidebar_title.png": 78561,
	"./yellowWhite/main/trashBinLogo.png": 18621,
	"./yellowWhite/other_modal/OtherActiveTab.png": 94381,
	"./yellowWhite/other_modal/OtherInactiveTab.png": 30795,
	"./yellowWhite/other_modal/OtherLongImagePlaceholder.png": 733,
	"./yellowWhite/other_modal/OtherModalContainer.png": 16772,
	"./yellowWhite/other_modal/OtherModalHeader.png": 55499,
	"./yellowWhite/other_modal/helpIconRound.png": 85845,
	"./yellowWhite/other_modal/othermodal_xbtn.png": 56525,
	"./yellowWhite/other_modal/othermodalsbg.png": 29166,
	"./yellowWhite/other_modal/poplogo.png": 68556,
	"./yellowWhite/other_modal/withdraw_success.png": 24612,
	"./yellowWhite/safeBox/GreenSumthing.png": 91317,
	"./yellowWhite/safeBox/divider.png": 93801,
	"./yellowWhite/safeBox/gameWalletIcon.png": 65872,
	"./yellowWhite/safeBox/safeEnter.png": 93161,
	"./yellowWhite/safeBox/safeReset.png": 91004,
	"./yellowWhite/safeBox/safeboxButton.png": 68911,
	"./yellowWhite/safeBox/transferFromIcon.png": 94392,
	"./yellowWhite/safeBox/transferToIcon.png": 51729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 73346;